import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class FlinkTitleStrategy extends TitleStrategy {
  private readonly appName = environment.production ? 'Flink' : 'Flink DEV';

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    this.title.setTitle(routeTitle ? `${routeTitle} | ${this.appName}` : this.appName);
  }
}
